/**
 * Quarter tile configuration for rendering quarterly vs yearly breakdowns.
 * 943-X applications show year tiles; 941-X (default) shows quarter tiles.
 */

const QUARTERLY_TILES = [
  { title: 'Q1 2020', quarter: 'q12020' },
  { title: 'Q2 2020', quarter: 'q22020' },
  { title: 'Q3 2020', quarter: 'q32020' },
  { title: 'Q4 2020', quarter: 'q42020' },
  { title: 'Q1 2021', quarter: 'q12021' },
  { title: 'Q2 2021', quarter: 'q22021' },
  { title: 'Q3 2021', quarter: 'q32021' },
  { title: 'Q4 2021', quarter: 'q42021' }
]

const YEARLY_TILES = [
  { title: '2020', quarter: 'q42020' },
  { title: '2021', quarter: 'q42021' }
]

/**
 * Returns the appropriate tile configuration based on form type.
 * @param {String} formType - '941-X' (default/quarterly) or '943-X' (yearly)
 * @returns {{ title: String, quarter: String }[]}
 */
export const getQuarterTiles = (formType) =>
  formType === '943-X' ? YEARLY_TILES : QUARTERLY_TILES
